import axios from '../utils/axios';

const apiPrefix = '/api/notifications';

const getNotifications = async () => {
	const result = await axios.get(`${apiPrefix}`);

	return result?.data;
};

const markNotificationsAsRead = async () => {
	const result = await axios.get(`${apiPrefix}/mark-as-read`);

	return result?.data;
};

export { getNotifications, markNotificationsAsRead };
